export const SELECTED_COMPANY = "SELECTED_HOLISTIC_COMPANY";
export const SELECTED_MD_ORGANIZATION = "SELECTED_MD_COMPANY";

export const PAYOUTS_TOKEN = "PAYOUTS_TOKEN";
